import { render, staticRenderFns } from "./NewDataTransformation.vue?vue&type=template&id=5f86f312&scoped=true"
import script from "./NewDataTransformation.vue?vue&type=script&lang=js"
export * from "./NewDataTransformation.vue?vue&type=script&lang=js"
import style0 from "./NewDataTransformation.vue?vue&type=style&index=0&id=5f86f312&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f86f312",
  null
  
)

export default component.exports